import React from "react";

const SectionLabel = ({ children, gold = false, center = false, className = "" }) => (
  <div
    className={`eyebrow ${gold ? "gold" : ""} ${className}`}
    style={center ? { justifyContent: "center" } : undefined}
  >
    {children}
  </div>
);

export default SectionLabel;
